import { SxProps, Theme, Typography } from '@mui/material';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import useWindowSize from '../../../hooks/useWindowSize';
import { selectContentBackgroundColor } from '../../../store/selectors/derived';
import { getPrimaryTextColor } from '../../../util/ui';

interface IProps {
  children: React.ReactNode;
  sx?: SxProps<Theme>;
}

export const Title: React.FC<IProps> = ({ children, sx }) => {
  const { mobile } = useWindowSize();

  const bgColor = useSelector(selectContentBackgroundColor);

  const textColor = useMemo(() => {
    return getPrimaryTextColor(bgColor);
  }, [bgColor]);

  return (
    <Typography
      variant={mobile ? 'h6' : 'h5'}
      fontWeight="medium"
      color={textColor}
      sx={{ mb: mobile ? 2 : 3, mt: mobile ? 3 : 4, ...sx }}
    >
      {children}
    </Typography>
  );
};
